import type {
  Configuration,
  CreateRoleRequest,
  UpdateRoleRequest,
} from '@repo/api-gw-sdk';
import { IamApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/roles';

// The list pages at 50 by default and offset paging over unordered roles can skip rows, so one large page.
const ALL_ROLES_PAGE_SIZE = 1000;

export const roles = (httpClient: HttpClient, config: Configuration) => {
  const iamApi = new IamApi(config);

  const listRoles = () => iamApi.listRoles(undefined, ALL_ROLES_PAGE_SIZE);

  return {
    useList: () => httpClient.execute(listRoles, baseUrl, ''),
    create: (createRoleInput: CreateRoleRequest) =>
      iamApi.createRole(createRoleInput),
    update: (id: string, updateRoleInput: UpdateRoleRequest) =>
      iamApi.updateRole(id, updateRoleInput),
    delete: (id: string) => iamApi.deleteRole(id),
    getRoleUsage: (id: string) => iamApi.getRoleUsage(id),
    useListPermissions: () =>
      httpClient.execute(
        iamApi.listPermissions.bind(iamApi),
        baseUrl,
        '/permissions'
      ),
  };
};
